// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"96e26188","439":"09685642","498":"26164226","703":"1698d654","921":"0b2922fe"}[chunkId] + ".chunk.js";
};